import type { operations } from '@connected/api-client/api.generated';

import { api } from '@connected/api-client';

export const portaalQueryOptions = {
    files: {
        electricalProject: (props: operations['DownloadElectricalProjectFilePortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/files/download', {
            params: {
                query: {
                    ElectricalProjectFileId: props.ElectricalProjectFileId,
                    ImageQuality: props.ImageQuality,
                },
            },
            parseAs: 'blob',
        }),
    },
    electrical: {
        distributionBoards: {
            list: (props: operations['ListElectricalProjectDistributionBoardPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/distributionboards/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                        Kinds: props.Kinds,
                    },
                },
            }),
            view: (props: operations['ViewElectricalProjectDistributionBoardPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/distributionboards/view', {
                params: {
                    query: {
                        ElectricalProjectDistributionBoardId: props.ElectricalProjectDistributionBoardId,
                    },
                },
            }),
        },
        documents: {
            list: (props: operations['ListElectricalProjectDocumentPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/documents/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                    },
                },
            }),
            download: (props: operations['DownloadElectricalProjectDocumentPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/documents/download', {
                params: {
                    query: {
                        DocumentId: props.DocumentId,
                    },
                },
            }),
            downloadBlob: (props: operations['DownloadElectricalProjectDocumentPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/documents/download', {
                params: {
                    query: {
                        DocumentId: props.DocumentId,
                    },
                },
                parseAs: 'blob',
            }),
        },
        finalcircuits: {
            list: (props: operations['ListElectricalProjectFinalCircuitPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/finalcircuits/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                        Kind: props.Kind,
                        // The kind 'FinalCircuit' is deprecated
                    },
                },
            }),
            view: (props: operations['ViewElectricalProjectFinalCircuitPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/finalcircuits/view', {
                params: {
                    query: {
                        ElectricalProjectFinalCircuitId: props.ElectricalProjectFinalCircuitId,
                    },
                },
            }),

        },
        project: {
            list: (props: operations['ListElectricalProjectPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/list', {
                params: {
                    query: {
                        ObjectId: props.ObjectId,
                    },
                },
            }),
            view: (props: operations['ViewElectricalProjectPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/view', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                    },
                },
            }),
            objectView: (props: operations['ViewElectricalProjectObjectQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/electrical/projects/objects/view', {
                params: {
                    query: {
                        ElectricalProjectVersionId: props.ElectricalProjectVersionId,
                    },
                },
            }),
            downloadDocument({
                DownloadElectricalProjectDocumentPortalQueryResult,
            }: {
                DownloadElectricalProjectDocumentPortalQueryResult: string;
            }) {
                return api.queryOptions('get', '/api/v2/portal/electrical/projects/documents/download', {
                    params: {
                        query: {
                            DocumentId: DownloadElectricalProjectDocumentPortalQueryResult,
                        },
                    },
                    parseAs: 'blob',
                });
            },
            projectObjectList({
                organizationId,
                enabled = true,
            }: { organizationId?: string; enabled?: boolean } = {}) {
                return api.queryOptions(
                    'get',
                    '/api/v2/electrical/projects/list',
                    {
                        params: {
                            query: {
                                OrganizationId: organizationId!,
                                Select: {
                                    ObjectId: true,
                                    CurrentElectricalProjectVersionId: true,
                                    Status: true,
                                },
                                Sort: ['CreateDateDesc'],
                                PageNumber: 1,
                                PageSize: 100,
                            },
                        },
                    },
                    {
                        enabled,
                    },
                );
            },
        },
        observations: {
            list: (props: operations['ListElectricalProjectObservationPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/observations/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                        ObjectKind: props.ObjectKind,
                    },
                },
            }),
            listPV: (props: operations['ListElectricalProjectObservationPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/observations/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                        ObjectKind: props.ObjectKind,
                        ElectricalProjectPVInverterId: props.ElectricalProjectPVInverterId,
                    },
                },
            }),
            view: (props: operations['ViewElectricalProjectObservationPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/observations/view', {
                params: {
                    query: {
                        ElectricalProjectObservationId: props.ElectricalProjectObservationId,
                    },
                },
            }),
        },
        pvInverter: {
            list({
                ElectricalProjectId,
            }: {
                ElectricalProjectId: string;
            }) {
                return api.queryOptions('get', '/api/v2/portal/electrical/projects/pvinverters/list', {
                    params: {
                        query: {
                            ElectricalProjectId,
                        },
                    },
                });
            },
            projectView({
                ElectricalProjectPVInverterId,
            }: {
                ElectricalProjectPVInverterId: string;
            }) {
                return api.queryOptions('get', '/api/v2/portal/electrical/projects/pvinverters/view', {
                    params: {
                        query: {
                            ElectricalProjectPVInverterId,
                        },
                    },
                });
            },
            view({
                ElectricalProjectId,
            }: {
                ElectricalProjectId: string;
            }) {
                return api.queryOptions('get', '/api/v2/portal/electrical/projects/pvinstallations/view', {
                    params: {
                        query: {
                            ElectricalProjectId,
                        },
                    },
                });
            },
        },
        planning: {
            planningList({
                organizationId,
                startDate,
                periodKind,
            }: {
                organizationId: string;
                startDate: string;
                periodKind: 'OneDay' | 'OneWeek' | 'OneMonth';
            }) {
                return api.queryOptions('get', '/api/v2/electrical/projects/planning/list', {
                    params: {
                        query: {
                            OrganizationId: organizationId,
                            PeriodKind: periodKind,
                            StartDate: startDate,
                        },
                    },
                });
            },
        },
        technicalDrawings: {
            list: (props: operations['ListElectricalProjectTechnicalDrawingPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/electrical/projects/technicaldrawings/list', {
                params: {
                    query: {
                        ElectricalProjectId: props.ElectricalProjectId,
                    },
                },
            }),
        },
        measurementDevicesCalibrations: {
            create: {
                get: api.queryOptions('get', '/api/v2/electrical/measurementdevices/calibrations/files/create', {}),
            },
        },
        users: {
            signatureValidation: () => api.queryOptions('get', '/api/v2/users/files/signatures/create'),
            userFiles({
                userId,
            }: {
                userId: string;
            }) {
                return api.queryOptions('get', '/api/v2/users/files/list', {
                    params: {
                        query: {
                            UserId: userId,
                            PageNumber: 1,
                            PageSize: 100,
                            Description: true,
                            Select: {
                                Description: true,
                                UserId: true,
                                File: {
                                    FileName: true,
                                    FileContentType: true,
                                    FileSize: true,
                                    FileId: true,
                                },
                            },
                            Sort: ['Kind'],
                        },
                    },
                    // parseAs: 'blob',
                });
            },
            downloadUserFile({
                userFileId,
            }: {
                userFileId: string;
            }) {
                return api.queryOptions('get', '/api/v2/users/files/download', {
                    params: {
                        query: {
                            UserFileId: userFileId,
                            ImageQuality: 'Original',
                        },
                    },
                    parseAs: 'blob',
                });
            },
        },
    },
    portal: {
        objects: {
            list: (props: operations['ListObjectPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/objects/list', {
                params: {
                    query: {
                        OrganizationId: props?.OrganizationId,
                    },
                },
            }),
            view: (props: operations['ViewObjectPortalQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/objects/view', {
                params: {
                    query: {
                        ObjectId: props.ObjectId,
                    },
                },
            }),
        },
    },
    objects: {
        list: (props?: operations['ListObjectQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/portal/objects/list', {
            params: {
                query: {
                    OrganizationId: props?.OrganizationId,
                    Select: null,
                    Sort: null,
                    PageNumber: null,
                    PageSize: null,
                },
            },
        }),
        listAuthObjects: (props?: operations['ListObjectQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/objects/list', {
            params: {
                query: {
                    OrganizationId: props?.OrganizationId,
                    Select: null,
                    Sort: null,
                    PageNumber: null,
                    PageSize: null,
                },
            },
        }),
        download: (props: operations['DownloadObjectImageQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/objects/images/download', {
            params: {
                query: {
                    ObjectId: props.ObjectId,
                    ImageQuality: 'Original',
                },
            },
            parseAs: 'blob',
        }),
    },
    organizations: {
        list: (props?: operations['ListOrganizationQuery_Get']['parameters']['query']) => api.queryOptions('get', '/api/v2/organizations/list', {
            params: {
                query: {
                    PageNumber: props?.PageNumber ?? 1,
                    PageSize: props?.PageSize ?? 100,
                    Select: {
                        Name: true,
                        Description: true,
                        ElectricalOrganizationKind: true,
                        LogoOrganizationFileId: true,
                        ChamberOfCommerceNumber: true,
                        LegalPersonKind: true,
                        LastActivityDate: true,
                        LastActivityUser: true,
                    },
                    Sort: ['Name'],
                },
            },
        }),
        view({ orgainsationId,
        }: {
            orgainsationId: string;
        }) {
            return api.queryOptions('get', '/api/v2/organizations/view', {
                params: {
                    query: {
                        OrganizationId: orgainsationId,
                    },
                },
            });
        },
        logo({ orgainsationId, ImageQuality,
        }: {
            orgainsationId: string;
            ImageQuality: 'Original' | 'OriginalWebp' | 'ExtraLarge' | 'Large' | 'Medium' | 'Small' | 'ExtraSmall';
        }) {
            return api.queryOptions('get', '/api/v2/organizations/files/logos/download', {
                params: {
                    query: {
                        OrganizationId: orgainsationId,
                        ImageQuality,
                    },
                },
                parseAs: 'blob',
            });
        },
    },
    accounts: {
        view: () => api.queryOptions('get', '/api/v2/accounts/settings/edit', {

        }),
    },
    users: {
        userIdsOptions({ organisationId }: { organisationId: string }) {
            return api.queryOptions('get', '/api/v2/users/list', {
                params: {
                    query: {
                        OrganizationId: organisationId,
                        PageSize: 100,
                        PageNumber: 1,
                        Sort: ['RolesDesc'],
                        Select: {
                            UserId: true,
                        },
                    },
                },
            });
        },
    },
    measurementDevices: {
        selectableMeasurementDeviceEditOptions({
            electricalMeasurementDeviceId,
        }: {
            electricalMeasurementDeviceId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/measurementdevices/edit', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceId: electricalMeasurementDeviceId,
                    },
                },
            });
        },
        listMeasurementDeviceCalibrationFileOptions({
            electricalMeasurementDeviceId,
            ekectricalMeasurementDeviceCalibrationId,
        }: {
            electricalMeasurementDeviceId: string;
            ekectricalMeasurementDeviceCalibrationId?: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/measurementdevices/calibrations/files/list', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceId: electricalMeasurementDeviceId,
                        ElectricalMeasurementDeviceCalibrationId: ekectricalMeasurementDeviceCalibrationId,
                        PageNumber: 1,
                        PageSize: 100,
                        Sort: ['CreateDateDesc'],
                        Select: {
                            Description: true,
                            FileName: true,
                            File: {
                                fileId: true,
                                fileName: true,
                                fileSize: true,
                                FileContentType: true,
                                StartDate: true,
                            },
                        },
                    },
                },
            });
        },
        listMeasurementDeviceCalibrationsOptions({
            electricalMeasurementDeviceId,
        }: {
            electricalMeasurementDeviceId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/measurementdevices/calibrations/list', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceId: electricalMeasurementDeviceId,
                        PageNumber: 1,
                        PageSize: 100,
                    },
                },
            });
        },
        DownloadElectricalMeasurementDeviceCalibrationFile({
            electricalMeasurementDeviceCalibrationFileId,
        }: {
            electricalMeasurementDeviceCalibrationFileId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/measurementdevices/calibrations/files/download', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceCalibrationFileId: electricalMeasurementDeviceCalibrationFileId,
                        ImageQuality: 'Original',
                    },
                },
                parseAs: 'blob',
            });
        },
        DeleteElectricalMeasurementDevice({
            electricalMeasurementDeviceCalibrationId,
        }: {
            electricalMeasurementDeviceCalibrationId: string;
        }) {
            return api.queryOptions('delete', '/api/v2/electrical/measurementdevices/calibrations/delete', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceCalibrationId: electricalMeasurementDeviceCalibrationId,
                    },
                },
            });
        },
        DeleteElectricalMeasurementDeviceCalibrationFile({
            electricalMeasurementDeviceCalibrationId,
        }: {
            electricalMeasurementDeviceCalibrationId: string;
        }) {
            return api.queryOptions('delete', '/api/v2/electrical/measurementdevices/calibrations/delete', {
                params: {
                    query: {
                        ElectricalMeasurementDeviceCalibrationId: electricalMeasurementDeviceCalibrationId,
                    },
                },
            });
        },
    },
    norms: {
        ListElectricalInspectionActiveNormList({
            organizationId,
        }: {
            organizationId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/inspectionnorms/lists/list', {
                params: {
                    query: {
                        OrganizationId: organizationId,
                        Sort: ['StatusDesc'],
                        PageNumber: 1,
                        PageSize: 100,
                        Status: {
                            Filters: [
                                {
                                    Value: 'Active',
                                    ExpressionKind: 'Equal',
                                },
                            ],
                        },
                        Select: {
                            Description: true,
                            Status: true,
                        },
                    },
                },
            });
        },
        ListElectricalInspectionNormItems({
            ElectricalInspectionNormListId,
        }: {
            ElectricalInspectionNormListId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/inspectionnorms/items/list', {
                params: {
                    query: {
                        ElectricalInspectionNormListId: ElectricalInspectionNormListId ?? '',
                        Sort: ['OrderDesc'],
                        PageNumber: 1,
                        PageSize: 100,
                        Select: {
                            Description: true,
                            InspectionKinds: true,
                            IsCustomInput: true,
                            Name: true,
                            NormKind: true,
                            Order: true,
                        },
                    },
                },
            });
        },
    },
    recommendations: {
        listRecommendations({
            organizationId,
        }: {
            organizationId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/observationstandardtexts/items/list', {
                params: {
                    query: {
                        OrganizationId: organizationId,
                        Sort: ['ObjectKind'],
                        PageNumber: 1,
                        PageSize: 100,
                        Select: {
                            Description: true,
                            TextKind: true,
                            ObjectKind: true,
                            Order: true,
                        },
                        TextKind: {
                            Filters: [
                                {
                                    Value: 'Recommendation',
                                    ExpressionKind: 'Equal',
                                },
                            ],
                        },
                    },
                },
            });
        },
    },
    observations: {
        listObservations({
            organizationId,
        }: {
            organizationId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/observationstandardtexts/items/list', {
                params: {
                    query: {
                        OrganizationId: organizationId,
                        Sort: ['ObjectKind'],
                        PageNumber: 1,
                        PageSize: 100,
                        Select: {
                            Description: true,
                            TextKind: true,
                            ObjectKind: true,
                            Order: true,
                        },
                        TextKind: {
                            Filters: [
                                {
                                    Value: 'Remark',
                                    ExpressionKind: 'Equal',
                                },
                            ],
                        },
                    },
                },
            });
        },
    },
    checklists: {
        listChecklist({
            electricalCheckListId,
        }: {
            electricalCheckListId: string;
        }) {
            return api.queryOptions('get', '/api/v2/electrical/checklists/items/list', {
                params: {
                    query: {
                        ElectricalCheckListId: electricalCheckListId,
                        Sort: ['Description'],
                        PageNumber: 1,
                        PageSize: 100,
                        Select: {
                            Description: true,
                            EnableNotApplicable: true,
                            EnableObservations: true,
                            Kind: true,
                            NegativeLabelText: true,
                            NotApplicableLabelText: true,
                            Order: true,
                            PositiveLabelText: true,
                        },
                    },
                },
            });
        },
    },
};
